const routes = [
    {
        path: '/admin/dashboard',
        component: () => import('../Admin/Dashboard.vue'),
        name: 'dashboard',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/events',
        component: () => import('../Admin/Events/Index.vue'),
        name: 'admin.events',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/event/create',
        component: () => import('../Admin/Events/Create.vue'),
        name: 'event.create',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/event/edit/:id',
        component: () => import('../Admin/Events/Edit.vue'),
        name: 'event.edit',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/event/show/:id',
        component: () => import('../Admin/Events/Show.vue'),
        name: 'admin.event',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/event/online-events',
        component: () => import('../Admin/Events/Online.vue'),
        name: 'event.online-events',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/event/author-events/:id',
        component: () => import('../Admin/Events/AuthorEvents.vue'),
        name: 'event.author-events',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/speakers',
        component: () => import('../Admin/Speakers/Index.vue'),
        name: 'admin.speakers',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/speaker/create',
        component: () => import('../Admin/Speakers/Create.vue'),
        name: 'speaker.create',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/speaker/edit/:id',
        component: () => import('../Admin/Speakers/Edit.vue'),
        name: 'speaker.edit',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/speaker/show/:id',
        component: () => import('../Admin/Speakers/Show.vue'),
        name: 'speaker.show',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/regions',
        component: () => import('../Admin/Regions/Index.vue'),
        name: 'admin.regions',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/reservations',
        component: () => import('../Admin/Reservations/Index.vue'),
        name: 'admin.reservations',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/reservation/create',
        component: () => import('../Admin/Reservations/Create.vue'),
        name: 'reservation.create',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/clients',
        component: () => import('../Admin/Clients/Index.vue'),
        name: 'admin.clients',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/users',
        component: () => import('../Admin/Users/Index.vue'),
        name: 'admin.users',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/consultants',
        component: () => import('../Admin/Consultants/Index.vue'),
        name: 'admin.consultants',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/leads',
        component: () => import('../Admin/Leads/Index.vue'),
        name: 'admin.leads',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/archives',
        component: () => import('../Admin/Archives/Index.vue'),
        name: 'admin.archives',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/admin_users',
        component: () => import('../Admin/AdminUsers/Index.vue'),
        name: 'admin.admin_users',
        meta: { requiresAuth: true },
    },
        {
        path: '/admin/admin_user/create',
        component: () => import('../Admin/AdminUsers/Create.vue'),
        name: 'admin_user.create',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/admin_user/edit/:id',
        component: () => import('../Admin/AdminUsers/Edit.vue'),
        name: 'admin_user.edit',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/admin_user/show/:id',
        component: () => import('../Admin/AdminUsers/Show.vue'),
        name: 'admin.admin_user',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/slideshows',
        component: () => import('../Admin/SlideShows/Index.vue'),
        name: 'admin.slideshows',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/slideshow/create',
        component: () => import('../Admin/SlideShows/Create.vue'),
        name: 'slideshow.create',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/slideshow/edit/:id',
        component: () => import('../Admin/SlideShows/Edit.vue'),
        name: 'slideshow.edit',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/slideshow/show/:id',
        component: () => import('../Admin/SlideShows/Show.vue'),
        name: 'admin.slideshow',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/identities',
        component: () => import('../Admin/Identities/Index.vue'),
        name: 'admin.identities',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/identity/show/:id',
        component: () => import('../Admin/Identities/Show.vue'),
        name: 'identities.show',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/areas',
        component: () => import('../Admin/Areas/Index.vue'),
        name: 'admin.areas',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/area/create',
        component: () => import('../Admin/Areas/Create.vue'),
        name: 'areas.create',
        meta: { requiresAuth: true },
    },   
     {
        path: '/admin/area/edit/:id',
        component: () => import('../Admin/Areas/Edit.vue'),
        name: 'areas.edit',
        meta: { requiresAuth: true },
    }, 
    {
        path: '/admin/tickets',
        component: () => import('../Admin/Tickets/Index.vue'),
        name: 'admin.tickets',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/orders',
        component: () => import('../Admin/Reservations/Order.vue'),
        name: 'admin.orders',
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/reservation/edit/:id',
        component: () => import('../Admin/Reservations/Edit.vue'),
        name: 'reservations.edit',
        meta: { requiresAuth: true },
    }, 
    {   path: '/admin/login', 
        component: () => import('../Auth/Login.vue'),
        name: 'login' 
    },
    {   path: '/admin/register', 
        component: () => import('../Auth/Register.vue'),
        name: 'register'
    },
    // when logged-in
    {
        path: '/admin/forgot_password',
        component: () => import('../Auth/Password.vue'),
        name: 'password',
    },
    // when not logged-in
    {
        path: '/admin/forgot-password',
        component: () => import('../Auth/ForgotPassword.vue'),
        name: 'forgot',
    },
    {
        path: '/admin/reset-password/:token',
        component: () => import('../Auth/ResetPassword.vue'),
        name: 'reset',
    },
    {
        path: '/*',
        component: () => import('../Pages/404.vue'),
        name: '404'
    },
]


export default routes;